import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { useDispatch } from 'react-redux';
import { resetAllDirty } from '../../app/features/formDirtySlice';

interface UnsavedChangesModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
}

const UnsavedChangesModal: React.FC<UnsavedChangesModalProps> = ({
  show,
  onHide,
  onConfirm,
}) => {
  const dispatch = useDispatch();

  const handleStayOnPage = () => {
    onHide();
  };

  const handleLeavePage = () => {
    dispatch(resetAllDirty());
    onConfirm();
  };

  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      backdrop={true}
      keyboard={false} 
      centered
      animation={false}
    >
      <Modal.Header>
        <Modal.Title>
          <FontAwesomeIcon icon={faExclamationTriangle} className="me-2 text-warning" />
          You have unsaved changes.
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>Are you sure you want to leave this page?</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleStayOnPage}>
          Stay on Page
        </Button>
        <Button variant="primary" onClick={handleLeavePage}>
          Leave Page
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UnsavedChangesModal; 